import React from "react";

/**
 * Animated boolean toggle switch — replaces raw <input type="checkbox">
 * Props:
 *   name     string  — field name (for handleChange compatibility)
 *   checked  bool    — current value
 *   onChange fn      — receives a synthetic event { target: { name, type, checked } }
 *   label    string  — text label displayed beside the switch
 */
export default function ToggleSwitch({ name, checked, onChange, label }) {
  const handleChange = (e) => {
    onChange({ target: { name, type: "checkbox", checked: e.target.checked } });
  };

  return (
    <label className="toggle-switch">
      <input
        type="checkbox"
        name={name}
        checked={checked}
        onChange={handleChange}
      />
      <span className="toggle-switch-track">
        <span className="toggle-switch-knob" />
      </span>
      <span className="toggle-switch-label-text">{label}</span>
    </label>
  );
}
